var _style, _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-179 55.7 40.4 40.3",
    style: {
      enableBackground: "new -179 55.7 40.4 40.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2E2E2E;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-149.9,68.2l-13.5,13.5l-6-6c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l6.7,6.7c0.2,0.2,0.4,0.3,0.7,0.3 s0.5-0.1,0.7-0.3l14.2-14.2c0.4-0.4,0.4-1,0-1.4C-148.9,67.8-149.5,67.8-149.9,68.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-158.8,55.9c-11,0-20,9-20,20c0,11,9,20,20,20s20-9,20-20C-138.8,64.8-147.8,55.9-158.8,55.9z M-158.8,94.9 c-10.5,0-19-8.5-19-19c0-10.5,8.5-19,19-19s19,8.5,19,19C-139.8,86.3-148.3,94.9-158.8,94.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.2d335a773c495541ac9603606862fbe6.svg";
export { ForwardRef as ReactComponent };